import Axios from 'axios'

export const searchMixin = {
    methods: {
        async search(replaceSearchResults) {
            var vm = this

            if (replaceSearchResults) {
                vm.$store.dispatch('setLoading', true)
                vm.$store.dispatch('updateHasFeaturedItems', false)
                vm.$store.dispatch('resetSearchResults')
                vm.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
                vm.$store.dispatch('updateSearchPageCount', 0)
                vm.$store.dispatch('updateSearchResultCount', 0)
                vm.$store.dispatch('updateSearchResultsLoaded', 0)
            }

            try {
                const baseUrl = vm.searchApiUrl
                const baseQuery = vm.$store.getters.searchFiltersQuerystring()
                const params = new URLSearchParams(baseQuery)
                const requestUrl = `${baseUrl}?${params.toString()}`
                const response = await Axios.get(requestUrl)

                if (response && response.data && response.data.SearchResults) {

                    if (replaceSearchResults) {
                        vm.$store.dispatch('resetSearchResults')
                    }

                    vm.$store.dispatch('updateHasFeaturedItems', response.data.FeatureFirstTwoResults)
                    vm.$store.dispatch('updateHideTagsOnResults', response.data.HideTagsOnResults)
                    vm.$store.dispatch('updateTagsShownOnResults', response.data.TagsShownOnResults)
                    
                    vm.$store.dispatch('updateSearchPageCount', response.data.PageCount)
                    vm.$store.dispatch('updateSearchResultCount', response.data.ResultCount)
                    vm.$store.dispatch('updateSearchResults', response.data.SearchResults)
                    vm.$store.dispatch('updateSearchResultsLoaded', vm.$store.state.search.resultsLoaded + response.data.SearchResults.length)

                    window.dataLayer = window.dataLayer || []
                    window.dataLayer.push({
                        event: 'formSubmissionSuccess',
                        formId: 'search'
                    })
                } else {
                    vm.$store.dispatch('resetSearch')
                }
            } catch (error) {
                console.error('Search request failed:', error)
            } finally {
                vm.$store.dispatch('setLoading', false)
            }
        }
    }
}
